<script lang="ts">
  import iconSetData from '$lib/data/icon-set.json';
  import type { IconName } from '$lib/types/components';
  import { twMerge } from 'tailwind-merge';

  type IconSet = Record<IconName, string>;

  const iconSet: IconSet = iconSetData as IconSet;
  export let viewBox: string = '0 0 24 24';

  export let name: IconName;
</script>

{#if iconSet[name]}
  <svg
    {viewBox}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    class={twMerge('inline-block h-6 w-6', $$restProps.class)}
    role="img"
  >
    <title>{name} icon</title>
    <path d={iconSet[name]} fill-rule="evenodd" />
  </svg>
{/if}

<!--
@component
Render any icon in the iPhoneLife custom icon set by passing the desired icon in the name prop.
## Props
@prop name: string;
-->
